import { ReactNode } from "react";
import './styles.css';

interface Props {
    title?: ReactNode;
    input: ReactNode;
    extra?: ReactNode;
}

export const Filter = (props: Props) => {
    return (
        <div className="filter-group">
            {props.title ? <div className="title">{props.title}</div> : <></>}
            <div className='filter-input'>
                {props.input}
                {props.extra}
            </div>
        </div>
    );
};